import React from 'react';
import { MatchStat, Language } from '../../types';
import { Activity } from 'lucide-react';
import { t } from '../../i18n';

interface MatchStatsTabProps {
    stats: MatchStat[];
    lang: Language;
}

export const MatchStatsTab: React.FC<MatchStatsTabProps> = ({ stats, lang }) => {
    // 통계 데이터가 존재하는지 확인
    const hasStats = stats && stats.length > 0;

    return (
        <div className="animate-in fade-in duration-500 min-h-[300px]">
            {hasStats ? (
                <div className="p-6 md:p-8 divide-y divide-gray-50">
                    {stats.map((stat, i) => {
                        const hRaw = Number(String(stat.homeValue).replace(/[^0-9.]/g, '')) || 0;
                        const aRaw = Number(String(stat.awayValue).replace(/[^0-9.]/g, '')) || 0;
                        const total = hRaw + aRaw || 1;
                        return (
                            <div key={i} className="py-4 first:pt-0 last:pb-0">
                                <div className="flex justify-between items-center mb-2.5">
                                    <span className={`text-sm font-black tabular-nums ${hRaw > aRaw ? 'text-rose-500' : 'text-slate-400'}`}>{stat.homeValue}</span>
                                    <span className="text-[10px] font-black text-slate-400 uppercase tracking-widest">{t(lang, stat.label)}</span>
                                    <span className={`text-sm font-black tabular-nums ${aRaw > hRaw ? 'text-slate-900' : 'text-slate-400'}`}>{stat.awayValue}</span>
                                </div>
                                <div className="h-1.5 flex gap-1 rounded-full overflow-hidden bg-gray-50">
                                    <div className={`h-full rounded-full transition-all duration-1000 ${hRaw > aRaw ? 'bg-rose-500' : 'bg-slate-200'}`} style={{ width: `${(hRaw/total)*100}%` }} />
                                    <div className={`h-full rounded-full transition-all duration-1000 ${aRaw > hRaw ? 'bg-slate-900' : 'bg-slate-200'}`} style={{ width: `${(aRaw/total)*100}%` }} />
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div className="py-24 text-center px-6">
                    <div className="w-16 h-16 bg-slate-50 rounded-2xl flex items-center justify-center mx-auto mb-6">
                        <Activity size={32} className="text-slate-200" />
                    </div>
                    <h3 className="text-lg font-black text-slate-800 mb-2">{t(lang, 'awaitingData')}</h3>
                    <p className="text-xs font-bold text-slate-400 leading-relaxed max-w-[240px] mx-auto">{t(lang, 'awaitingDataDesc')}</p>
                </div>
            )}
        </div>
    );
};